import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faChevronLeft, faChevronRight, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import { apiService } from '../../../../services/apiService';
import { Modal, Tab, Tabs } from 'react-bootstrap';
import TaskHistory from '../I94Validation/TaskHistory';
import TaskKnowledge from '../I94Validation/TaskKnowledge';
import Assignments from '../I94Validation/Assignments';
import CaseDetails from '../CaseDetails/CaseDetails';
import OnboardingDiscussTab from '../I94Validation/OnboardingDiscussTab';
function CommunicationEligibility() {
    const location = useLocation();
    const parts_location = location.pathname.split("/");
    const onboardslug = parts_location[2] || null;
    const userid = parts_location[3] || null;
    const taskData = parts_location[4] || null;
    const permissionstest = JSON.parse(localStorage.getItem('permissions'));
    const [expanded, setExpanded] = useState(true);
        const navigate = useNavigate();
        const [showform, setShowform] = useState(true);
        const [showedit, setShowedit] = useState(false);
        const [editMode, setEditMode] = useState(false);
        const [loading, setLoading] = useState(true);
        const [status, setStatus] = useState("");
        const [jobseekerName, setJobseekername] = useState("");
        const [jobseekerid, setJobseekerid] = useState("");
        const [caseids, setcaseid] = useState("");
        
        const [activeTab, setActiveTab] = useState("overview");
        const [activeTabCase, setActiveTabCase] = useState("task");
        const [showSubmits, setShowSubmits] = useState(false);
        const [showCase, setShowCase] = useState(false);
        const [CaseAlldetail, setCaseAllDetail] = useState([]);
        const [showCurrcase, setCaseIdscurrent] = useState('');
        useEffect(() => {
            if(taskData){
                const fetchData = async () => {
                    try {
                        const response = await apiService.getRequest(`task/details/${taskData}`);
                        if (response.success && response.success === true) {
                            setCaseIdscurrent(response.data.case_og_id);
                        }
                    } catch (error) {
                        console.error("Error fetching onboarding data:", error);
                    } finally {
                        setLoading(false);
                    }
                };
    
                fetchData();
            }
        }, [taskData, navigate]);
        const fetchData = useCallback(async () => {
            if(onboardslug && userid && showCurrcase){
                try {
                const response = await apiService.getRequest(`/onboarding/${onboardslug}/${userid}/${showCurrcase}`);
                if (response.success && response.success === true) {
                    setCaseAllDetail(response.data.case);
                    setShowSubmits(response.can_submit);
                    setShowCase(response.data.can_see_case);
                    setJobseekername(response.data.jobseeker.name);
                    setJobseekerid(response.data.jobseeker.id);
                    setcaseid(response?.data);
                    
                    setStatus(response.data.status_string);
                    const refetchedData = response.data.form_data;
                    setFormData({
                        Q00010: refetchedData.Q00010,
                        Q00020: refetchedData.Q00020,
                        Q00030: refetchedData.Q00030,
                        Q00040: refetchedData.Q00040,
                        Q00050: refetchedData.Q00050,
                        Q00060: refetchedData.Q00060,
                        Q00070: refetchedData.Q00070,
                    });
                    if ((
                        (response && response.data.form_data && Object.keys(response.data.form_data).length === 0) ||
                        (response && response.data.form_data && (!response.data.form_data.Q00010 || Object.keys(response.data.form_data.Q00010).length === 0)))
                        && (response && response.data.status_string === "in-progress")
                    ){
                    setShowform(true);
                    }else{
                    setShowform(false);
                    }
                }else{
                    if(response.error_code === "E_PERMISSION_DENIED"){
                        toast.error(response.message || "Permission denied!");
                        navigate("/dashboard");
                    }else if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
                } catch (error) {
                console.error("Error fetching onboarding data:", error);
                } finally {
                setLoading(false);
                }
            }
        }, [onboardslug, userid, showCurrcase, navigate]);
        
        useEffect(() => {
            fetchData();
        }, [fetchData]);
    
        useEffect(() => {
            if(userid && showCurrcase){
                const fetchCurrentData = async () => {
                    try {
                    const response = await apiService.getRequest(`/current-onboarding/${userid}/${showCurrcase}`);
                    if (response.success && response.success === true) {
                        if(response && Array.isArray(response.onboarding) && response.onboarding.includes(onboardslug) && response.status && response.status["communication-eligibility"] === "in-progress"){
                            setShowedit(true);
                        }else{
                            setShowedit(false)
                        }
                    }
                    } catch (error) {
                    console.error("Error fetching onboarding data:", error);
                    } finally {
                    setLoading(false);
                    }
                };
                fetchCurrentData();
            }
        }, [ userid,onboardslug, showCurrcase]);
        const [formData, setFormData] = useState({
            Q00010: "",
            Q00020: "",
            Q00030: "",
            Q00040: "",
            Q00050: "",
            Q00060: "",
            Q00070: "",
        });
        const [errors, setErrors] = useState({});
        const [errorMessage, setErrorMessage] = useState('');
            // Handle input changes
        const handleInputChange = (e) => {
            const { name, value } = e.target;
            setFormData((prevData) => ({ ...prevData, [name]: value }));
            setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
        };
    
        // Validate form fields
        const validateForm = () => {
        const newErrors = {};
        if (!formData.Q00010) newErrors.Q00010 = "Pronounciation is requied.";
        if (!formData.Q00020) newErrors.Q00020 = "Reading Speed is required.";
        if (!formData.Q00030) newErrors.Q00030 = "Reading Accuracy is required.";
        if (!formData.Q00040) newErrors.Q00040 = "Casualness and laughter is required.";
        if (!formData.Q00050) newErrors.Q00050 = "Plan B is required.";
        if (!formData.Q00060) newErrors.Q00060 = "Body and Face Language is required.";
        if (!formData.Q00070) newErrors.Q00070 = "Result is required.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
        };
        // Handle form submission
        const [submitloader,setSubmitloader] = useState(false)
        const handleSubmit = async (e, triggerStatus) => {
        e.preventDefault();
        if (!validateForm()) {
            setErrorMessage('Please fix the errors before proceeding.');
            return;
        }
        setSubmitloader(true);
        try {
            const response = await apiService.postRequest(`onboarding/${onboardslug}/${userid}/submit`, formData);
    
            // Check response for success
            if (response && response.success === true) {
                setErrors({});
                setErrorMessage('');
                setEditMode(false);
                setShowform(false);
                if(response.success && response.status === "rejected"){
                    window.location.reload();
                }else{
                    if (triggerStatus) {
                        handleslectChange();
                    }
                    if (response.notify_toast) {
                        toast(response.message);
                    }
                    if(response && response.authenticate === false){
                        await apiService.postRequest('/auth/logout');
                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = '/login';
                    }
                }
            } else {
                setErrorMessage(response.message);
                if (response.errors) {
                    setErrors(response.errors);
                }
            }
        } catch (error) {
            console.log(error,'Failed. Please try again.');
        } finally {
            setSubmitloader(false); // Stop loader
        }
        };
        
    
        const [selectedStatus, setSelectedStatus] = useState("");
        const [show, setShow] = useState(false);
    
        const handleslectChange = () => {
            setSelectedStatus("completed");
            setShow(true);
        };
    
        const handleClose = () => setShow(false);
    
        const [statuserror,setStatuserror] = useState("");
    const [submitloader2,setSubmitloader2] = useState(false);
      const confirmStatusChange = async () => {
      setShow(false); // Close the modal
      setStatus(selectedStatus); // Update the status locally
      setSubmitloader2(true);
      try {
        const response = await apiService.postRequest(
          `/task/update/status/${taskData}`,
          {
            status: selectedStatus,
          }
        );
        if (response && response.success === true) {
          toast(response.message || "Status updated successfully!");
          window.location.reload();
          setStatuserror("");
        }else{
          setStatuserror(response.message);
          setStatus("in-progress");
          if(response && response.authenticate === false){
                await apiService.postRequest('/auth/logout');
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/login';
            }
        }
      } catch (error) {
        console.error("Error updating status:", error);
        toast.error("Failed to update status. Please try again.");
      }finally {
          setSubmitloader2(false); // Stop loader
      }
    };
  
    const [errorsCase, setErrorsCase] = useState({});
    const [errorsCaseMessage, setErrorMessageCase] = useState("");
    const [selectedCaseStatus, setSelectedCaseStatus] = useState("");
    const [showCasepop, setShowCasepop] = useState(false);
    const [loadingCase, setSubmitloaderCase] = useState(false);
    const [caseActionform, setCaseActionForm] = useState({
        status: "",
        justification: "",
    })

    const handleselectCase = (statussend) => {
        setSelectedCaseStatus(statussend);
        setShowCasepop(true);
        setCaseActionForm((prevData) => ({
            ...prevData,
            status: statussend,
        }));
    };
    const handleCloseCase = () => setShowCasepop(false);

    const handleInputCasedata = (e) => {
        const { name, value } = e.target;

        const newValue = name === "to_onboarding_id" ? Number(value) : value;

        setCaseActionForm((prevData) => ({
            ...prevData,
            [name]: newValue,
        }));

        setErrorsCase((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
    };

    const validateFormCase = () => {
        const newErrors = {};
        if (!caseActionform.justification) newErrors.justification = "Justification is required.";
        if (caseActionform.justification && caseActionform.justification.length < 3) {
            newErrors.justification = "justification must be at least 3 characters long.";
        }else if (caseActionform.justification && caseActionform.justification.length > 4000) {
            newErrors.justification = 'justification must be less than 4000 characters long.';
        }
        setErrorsCase(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleCaseStatus = async (e) => {
        e.preventDefault();
        if (!validateFormCase()) {
            setErrorMessageCase('Please fix the errors before proceeding.');
            return;
        }
        setSubmitloaderCase(true);
        try {
            const response = await apiService.postRequest(`/task-cases/${CaseAlldetail.id}/status`, caseActionform);
            
            if (response && response.success === true) {
                fetchData();
                window.location.reload();
                setErrorMessageCase("");
                setShowCasepop(false);
                setCaseActionForm({
                    status: "",
                    justification: "",
                })
            } else {
                if (response.errors) {
                    setErrorsCase(response.errors);
                }
                toast(response.message || "Somthing went wrong!")
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.log(error,'Failed. Please try again.');
        } finally {
            setActiveTab("overview");
            setActiveTabCase("task");
            setSubmitloaderCase(false); // Stop loader
        }
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container_validate' style={{ flexGrow: 1 }}>
            <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead mb-3">
            <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> 
                    <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                    <b className="formatid_copyclip my-0 fw-bold text-decoration-none" style={{color:"#1A5298", width:"max-content"}}
                        onClick={async () => {
                            const url = `${window.location.origin}${caseids?.case?.case_link}`;
                            const title = "Onboarding " + caseids?.jobseeker?.name + " - " + caseids?.jobseeker?.formatted_id;
                            const textPlain = `${caseids?.case?.case_formatted_id}: ${title}\n${url}`;
                            const textHtml = `<a href="${url}" target="_blank">${caseids?.case?.case_formatted_id}: ${title}</a>`;
                            try {
                            await navigator.clipboard.write([
                                new ClipboardItem({
                                "text/html": new Blob([textHtml], { type: "text/html" }),
                                "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                }),
                            ]);
                            toast("Link copied to clipboard");
                            } catch (err) {
                            console.error("Failed to copy: ", err);
                            toast("Failed to copy link");
                            }
                        }}
                        >
                        {caseids?.case?.case_formatted_id}
                    </b>
                    <FontAwesomeIcon className='angleright' icon={faAngleRight} />
                    <b className="formatid_copyclip my-0 fw-bold text-decoration-none" style={{color:"#1A5298", width:"max-content"}}
                        onClick={async () => {
                            const url = `${window.location}`;
                            const title = "Onboarding " + caseids?.jobseeker?.name + " - " + caseids?.jobseeker?.formatted_id;
                            const textPlain = `${caseids?.task?.task_format_id} - ${caseids?.case?.case_formatted_id}: ${title}\n${url}`;
                            const textHtml = `<a href="${url}" target="_blank">${caseids?.case?.case_formatted_id}: ${title}</a>`;
                            try {
                            await navigator.clipboard.write([
                                new ClipboardItem({
                                "text/html": new Blob([textHtml], { type: "text/html" }),
                                "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                }),
                            ]);
                            toast("Link copied to clipboard");
                            } catch (err) {
                            console.error("Failed to copy: ", err);
                            toast("Failed to copy link");
                            }
                        }}
                        >
                        {caseids?.task?.task_format_id}
                    </b>
                </span>            </Grid>
            {loading ? 
                <div className='d-flex justify-content-center w-100'>
                    <img style={{ width: "100px" }} src={require('../../../../assets/pinkloader.gif')} alt='Loading...' />
                </div> :
                <Grid size={{sm:12}} container className="main_jobseeker justify-content-between">
                    <Grid size={{ lg: expanded ? 7.6 : 11.5, md: expanded ? 7 : 11, xs: 12 }} sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)" }} container className={`pe-4 tab_controllers ${ expanded && "control_splits"} align-items-start align-content-start flex-row-reverse justify-content-between`}>
                        <Grid container className="case_control_btn" justifyContent="flex-end">
                            {showCase && activeTabCase === "case" && <>
                            {CaseAlldetail?.status !== "suspend" && CaseAlldetail?.status !== "completed" && CaseAlldetail?.status !== "rejected" && <>
                                {CaseAlldetail?.status !== "hold" ?
                                    <button className='registersendbtn1 my-0' onClick={()=> handleselectCase("hold")}>Hold</button>:
                                    <button className='registersendbtn1 my-0' onClick={()=> handleselectCase("resume")}>Resume</button>
                                }
                            </>}
                            {CaseAlldetail?.status !== "hold" && CaseAlldetail?.status !== "completed" && CaseAlldetail?.status !== "rejected" && <>
                                {CaseAlldetail?.status !== "suspend" ?
                                <button className='registersendbtn1 my-0' onClick={()=> handleselectCase("suspend")}>Suspend</button>:
                                ""
                                }
                            </>}
                            </>}
                        </Grid>
                        <Tabs
                            activeKey={activeTabCase}
                            onSelect={(key) => setActiveTabCase(key)}
                            defaultActiveKey="task"
                            id="uncontrolled-tab-example" className="mb-4 drafttabs_tabs"
                        >
                            <Tab eventKey="task" title="Task">
                                <Grid size={{sm:12}} container alignItems="center">
                                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead border_botomer mario_fixers">
                                        <h3>Communication Eligibility <small className='small_headingstatuses'>{status&&<>{status === "completed" ? "Completed":status === "rejected"? "Rejected":"In Progress"}</>}</small></h3>
                                        {permissionstest && (permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) ? 
                                            <Link className='seekerondetail' to={`/user/jobseeker-details/${jobseekerid}`} target='_blank' >{caseids?.jobseeker?.formatted_id} - {jobseekerName}</Link>:
                                            <Link className='seekerondetail' to={`/user/jobseeker-profile/${jobseekerid}`} target='_blank' >{caseids?.jobseeker?.formatted_id} - {jobseekerName}</Link>
                                        }
                                    </Grid>
                                    {loading ? 
                                        <div className='d-flex justify-content-center w-100'>
                                            <img style={{ width: "100px" }} src={require('../../../../assets/pinkloader.gif')} alt='Loading...' />
                                        </div> :<>
                                        <Grid size={{xs:12}} container flexDirection="column" justifyContent="center" className={`tab_controllers ${ expanded && "control_splits"}`}>
                                            <Tabs
                                                activeKey={activeTab}
                                                onSelect={(key) => setActiveTab(key)}
                                                defaultActiveKey="overview"
                                                id="uncontrolled-tab-example" className="mt-4 drafttabs_tabs"
                                                >
                                                <Tab eventKey="overview" title="Overview" className={`${ expanded && "expanded-grid"}`}>
                                                    {(showform && showform === true) || (editMode && editMode === true) ? <>
                                                    <form className='w-100 mt-3'>
                                                        <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Pronounciation<small>*</small></span>
                                                                <select name="Q00010" disabled={!showSubmits}
                                                                value={formData.Q00010}
                                                                onChange={handleInputChange} 
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="High">High</option>
                                                                    <option value="Medium">Medium</option>
                                                                    <option value="Low">Low</option>
                                                                </select>
                                                                {errors.Q00010 && <p style={{color:"Red"}}>{errors.Q00010}</p>}
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Reading Speed<small>*</small></span>
                                                                <select name="Q00020" disabled={!showSubmits}
                                                                value={formData.Q00020}
                                                                onChange={handleInputChange} 
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="High">High</option>
                                                                    <option value="Medium">Medium</option>
                                                                    <option value="Low">Low</option>
                                                                </select>
                                                                {errors.Q00020 && <p style={{color:"Red"}}>{errors.Q00020}</p>}
                                                            </Grid>                          
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Reading Accuracy<small>*</small></span>
                                                                <select name="Q00030" disabled={!showSubmits}
                                                                value={formData.Q00030}
                                                                onChange={handleInputChange} 
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="High">High</option>
                                                                    <option value="Medium">Medium</option>
                                                                    <option value="Low">Low</option>
                                                                </select>
                                                                {errors.Q00030 && <p style={{color:"Red"}}>{errors.Q00030}</p>}
                                                            </Grid>                          
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Casualness and laughter<small>*</small></span>
                                                                <select name="Q00040" disabled={!showSubmits}
                                                                value={formData.Q00040}
                                                                onChange={handleInputChange} 
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="High">High</option>
                                                                    <option value="Medium">Medium</option>
                                                                    <option value="Low">Low</option>
                                                                </select>
                                                                {errors.Q00040 && <p style={{color:"Red"}}>{errors.Q00040}</p>}
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Plan B<small>*</small></span>
                                                                <select name="Q00050" disabled={!showSubmits}
                                                                value={formData.Q00050}
                                                                onChange={handleInputChange} 
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="High">High</option>
                                                                    <option value="Medium">Medium</option>
                                                                    <option value="Low">Low</option>
                                                                </select>
                                                                {errors.Q00050 && <p style={{color:"Red"}}>{errors.Q00050}</p>}
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Body and Face Language<small>*</small></span>
                                                                <select name="Q00060" disabled={!showSubmits}
                                                                value={formData.Q00060}
                                                                onChange={handleInputChange} 
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="High">High</option>
                                                                    <option value="Medium">Medium</option>
                                                                    <option value="Low">Low</option>
                                                                </select>
                                                                {errors.Q00060 && <p style={{color:"Red"}}>{errors.Q00060}</p>}
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Result<small>*</small></span>
                                                                <select name="Q00070" disabled={!showSubmits}
                                                                value={formData.Q00070}
                                                                onChange={handleInputChange} 
                                                                >
                                                                    <option value="">Select</option>
                                                                    <option value="Pass">Pass</option>
                                                                    <option value="Fail">Fail</option>
                                                                </select>
                                                                {errors.Q00070 && <p style={{color:"Red"}}>{errors.Q00070}</p>}
                                                            </Grid>
                                                            {errorMessage && <p style={{ color: 'red',width:"100%" }}>{errorMessage}</p>}
                                                            {showSubmits &&
                                                            <Grid size={{sm:12, xs:12}} container className="mt-2 consplit_btns gap-md-5 gap-3">
                                                                <button disabled={submitloader} className='registersendbtn2' onClick={(e) => handleSubmit(e, true)}>{submitloader2 ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Complete'}</button>
                                                                <button disabled={submitloader} type='submit' className='registersendbtn1' onClick={(e) => handleSubmit(e, false)}>{submitloader ? <img src={require('../../../../assets/pinkloader.gif')} alt=''/> : 'Save'}</button>
                                                                {editMode && 
                                                                    <button disabled={submitloader} className='registersendbtn1' onClick={()=> setEditMode(false)}>cancel</button>
                                                                }
                                                            </Grid>}
                                                        </Grid>
                                                    </form></>:
                                                    <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="i94viewvalidate">
                                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                            <span>Pronunciation<small>*</small></span>
                                                            <p>{formData.Q00010}</p>
                                                        </Grid>
                                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                            <span>Reading Speed<small>*</small></span>
                                                            <p>{formData.Q00020}</p>
                                                        </Grid>
                                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                            <span>Reading Accuracy<small>*</small></span>
                                                            <p>{formData.Q00030}</p>
                                                        </Grid>
                                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                            <span>Casualness and laughter<small>*</small></span>
                                                            <p>{formData.Q00040}</p>
                                                        </Grid>
                                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                            <span>Plan B<small>*</small></span>
                                                            <p>{formData.Q00050}</p>
                                                        </Grid>
                                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                            <span>Body and Face Language<small>*</small></span>
                                                            <p>{formData.Q00060}</p>
                                                        </Grid>
                                                        <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                            <span>Result<small>*</small></span>
                                                            <p>{formData.Q00070}</p>
                                                        </Grid>
                                                        {statuserror && <p style={{color:"Red",width:"100%"}}>{statuserror}</p>}
                                                        {showedit && showSubmits &&
                                                            <Grid size={{sm:12, xs:12}} container className="mt-2 consplit_btns gap-md-5 gap-3">
                                                                <button className='registersendbtn1' onClick={()=> setEditMode(true)}>Edit</button>
                                                                <button className='registersendbtn2' onClick={handleslectChange} disabled={!showedit}>{submitloader2 ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Complete'}</button>
                                                            </Grid>
                                                        }
                                                    </Grid>}
                                                </Tab>
                                                <Tab eventKey="assignment" title="Assignments">
                                                    {activeTab === "assignment" && <Assignments />}
                                                </Tab>
                                                <Tab eventKey="knowledge" title="Knowledge">
                                                    {activeTab === "knowledge" && <TaskKnowledge />}
                                                </Tab>
                                                <Tab eventKey="history" title="History" style={{ flexGrow: 1 }}>
                                                    {activeTab === "history" && <TaskHistory />}
                                                </Tab>
                                            </Tabs>
                                        </Grid>
                                    </>}
                                </Grid>
                            </Tab>
                            {showCase &&
                            <Tab eventKey="case" title="Case">
                                {activeTabCase === "case" && <CaseDetails expanded={expanded}/>}
                            </Tab>}
                        </Tabs>
                    </Grid>
                    <Grid alignContent="flex-start" size={{ lg: expanded ? 4.4 : 0.5, md: expanded ? 5 : 0.4, xs: 12, }} container className="border-start ps-3" sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)", overflow: "hidden", minWidth: expanded ? undefined : 0, }}>
                        <button onClick={() => setExpanded((prev) => !prev)} className='main_expanddisbtn'>
                            {expanded ? <FontAwesomeIcon icon={faChevronRight} /> : <FontAwesomeIcon icon={faChevronLeft} />}
                        </button>
                        <Grid size={{xs:12}} container className={ expanded ? "" : "d-none"}>
                            <OnboardingDiscussTab showCase={showCase} caseStatus={caseids?.case?.status}/>
                        </Grid>
                    </Grid>
                </Grid>}
            <Modal
                show={show} 
                onHide={handleClose}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}>
                    
                </Modal.Header>
                <Modal.Body>
                <div className="d-flex w-100 text-center flex-column align-items-center modal_register modal_statuscomplete">
                <FontAwesomeIcon className='statusicons' icon={faCircleExclamation} />
                    <p>
                    Are you sure you want to change the status to{" "}
                    <strong className='uppercasers'>{selectedStatus}</strong>?
                    </p>
                </div>
                </Modal.Body>
                <Modal.Footer>
                <button className='registersendbtn1 my-2 mx-4' onClick={handleClose}>
                    Cancel
                </button>
                <button className='registersendbtn2 my-2' onClick={confirmStatusChange}>
                    Confirm
                </button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showCasepop} 
                onHide={handleCloseCase}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}>
                    
                </Modal.Header>
                <Modal.Body>
                <div className="d-flex w-100 text-center flex-column align-items-center modal_register modal_statuscomplete">
                <FontAwesomeIcon className='statusicons' icon={faCircleExclamation} />
                    {selectedCaseStatus === "suspend" && <small className='fw-bold'>Suspending this case will also suspend the job seeker and block future login.</small>}
                    <p>Are you sure you want to change the status to{" "}<strong className='uppercasers'>{selectedCaseStatus}</strong>?</p>
                    <div className='d-flex w-100 flex-column align-items-start rollback_textarea'>
                        <span>Justification<small className='justify_astrickt'>*</small></span>
                        <textarea className='w-100' maxLength={4001} minLength={3} name='justification' value={caseActionform.justification} onChange={handleInputCasedata}/>
                        {errorsCase.justification && <p style={{color:"Red"}}>{errorsCase.justification}</p>}
                    </div>
                    {errorsCaseMessage && <p style={{color:"Red",width:"100%",textAlign:"left"}}>{errorsCaseMessage}</p>}
                </div>
                </Modal.Body>
                <Modal.Footer>
                <button className='registersendbtn1 my-2 mx-4' onClick={handleCloseCase}>
                    Cancel
                </button>
                <button className='registersendbtn2 my-2' onClick={handleCaseStatus}>
                    {loadingCase ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Confirm'}
                </button>
                </Modal.Footer>
            </Modal>
        </div>
    </div>
  )
}

export default CommunicationEligibility
